import { useMemo, useEffect } from 'react';
import { useAppDispatch } from '@/app/store';
import { useSelector } from '@/hooks/useSelector';
import { deselectDelivery } from '@/features/deliveries/deliveriesSlice';
import { ReceivingStatus } from '@/pages/Receiving/PageReceiving/types';
import { ReceivingFilters } from '@/hooks/useReceivingPage';

export const useReceivingDeliveries = (filters: ReceivingFilters) => {
  const dispatch = useAppDispatch();

  const { deliveryItems, selectedDeliveries } = useSelector(
    state => state.deliveries
  );

  const { PARTIAL, NEW, IN_USE, CONFIRMED } = ReceivingStatus;

  // ACTIVE
  const activeDeliveries = useMemo(() => {
    return deliveryItems.filter(delivery => {
      if (delivery.status === NEW && filters.new) return true;
      if (delivery.status === PARTIAL && filters.partial) return true;
      return delivery.status === IN_USE && filters.inUse;
    });
  }, [deliveryItems, filters, NEW, PARTIAL, IN_USE]);

  // CONFIRMED
  const confirmedDeliveries = useMemo(() => {
    return deliveryItems.filter(delivery => delivery.status === CONFIRMED);
  }, [deliveryItems, CONFIRMED]);

  // CLEANUP selezione
  useEffect(() => {
    const filteredCodes = new Set(activeDeliveries.map(d => d.codeDelivery));

    const toRemove = selectedDeliveries.filter(
      d => !filteredCodes.has(d.codeDelivery)
    );

    if (toRemove.length === 0) return;

    toRemove.forEach(d => dispatch(deselectDelivery(d)));
  }, [activeDeliveries, selectedDeliveries, dispatch]);

  return {
    activeDeliveries,
    confirmedDeliveries,
  };
};
